import React from "react";
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {TextField} from "@material-ui/core";

const styles = (theme) => ({
  filterControl: {
    minWidth: 80,
  },
  labelHidden: {
    display: 'none'
  },
  label: {
    transform: 'translate(14px, 10px) scale(0.75) !important'
  },
  input: {
    paddingTop: 26,
    paddingBottom: 11
  },
  inputMultiline: {
    marginTop: 8,
    paddingBottom: 0
  },
  inputAdornment: {
    marginTop: 15
  }
});

TextInputField.propTypes = {
  classes: PropTypes.object,
  InputProps: PropTypes.object,
  multiline: PropTypes.bool
};

function TextInputField({classes, InputProps, ...props}) {

  const { multiline } = props;

  const inputLabelClasses = {
    root: classes.label
  };

  const inputClasses = {
    input: multiline ? classes.inputMultiline : classes.input
  };

  InputProps = {
    classes: inputClasses,
      ...InputProps
  };

  return (
    <TextField
      {...props}
      InputLabelProps={{
        disableAnimation: false,
        shrink: false,
        classes: inputLabelClasses
      }}
      InputProps={InputProps}
    />
  );
}

export default withStyles(styles)(TextInputField);
